import { IThirdPartyTokenRepository } from "../../../domain/adapter/repository/IThirdPartyTokenRepository";
import CookieRepository from "../common/CookieRepository";

export default class ThirdPartyTokenRepository extends CookieRepository<string> implements IThirdPartyTokenRepository {
    constructor() {
        super("access_token");
    }

    getToken(): Promise<string | undefined> {
        return this.get();
    }

    removeToken(): Promise<void> {
        return this.clear();
    }
}
